import React from "react";
import { Reveal } from "./Reveal";

export const PageHero = ({ eyebrow, title, sub, testId }) => (
  <section className="relative bg-[#061A26] pt-40 pb-24 md:pt-48 md:pb-28 overflow-hidden" data-testid={testId}>
    <div className="absolute inset-0 film-lines opacity-40" aria-hidden="true" />
    <div className="relative max-w-[1320px] mx-auto px-6 md:px-10">
      <Reveal>
        <p className="eyebrow">{eyebrow}</p>
        <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-white max-w-3xl">
          {title}
        </h1>
        {sub && <p className="mt-6 text-base md:text-lg text-slate-400 leading-relaxed max-w-2xl">{sub}</p>}
      </Reveal>
    </div>
  </section>
);
